import { render, staticRenderFns } from "./ShortLink.vue?vue&type=template&id=490d7182"
import script from "./ShortLink.vue?vue&type=script&lang=js"
export * from "./ShortLink.vue?vue&type=script&lang=js"
import style0 from "./ShortLink.vue?vue&type=style&index=0&id=490d7182&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports